export default __webpack_public_path__ + "static/media/galleryBanner.ad764d2c.jpg";